<template>
  <ModalComponent
    :title="title"
    id="confirm_alert_modal"
    v-on:modalClosed="alertClosed"
  >
    <template v-slot:body>
      <p class="text-paragraph">
        {{ message }}
      </p>
    </template>
    <template v-slot:footer>
      <button
        type="button"
        @click="cancelAction"
        class="btn btn-outline-primary"
      >
        {{ cancellationButtonLabel }}
      </button>

      <button
        type="button"
        @click="confirmAction"
        class="btn"
        :class="`btn-${buttonColor}`"
      >
        <span
          v-if="submitting"
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        <span>
          {{ confirmationButtonLabel }}
        </span>
      </button>
    </template>
  </ModalComponent>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import type { IConfirmationAlert } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";

const submitting = ref(false);
const title = ref("");
const message = ref("");
const confirmationButtonLabel = ref("");
const cancellationButtonLabel = ref("");
const buttonColor = ref("");

let confirmCallback: IConfirmationAlert["confirmCallback"] = () => {};
let cancelCallback: IConfirmationAlert["cancelCallback"] = () => {};

onMounted(() => {
  EventBus.$on(
    EventBusNames.SHOW_CONFIRMATION_ALERT,
    ({
      title: newTitle = "Deseja continuar",
      message: newMessage = "Tem certeza que deseja continuar?",
      confirmationButtonLabel: newConfirmationButtonLabel = "Sim",
      cancellationButtonLabel: newCancellationButtonLabel = "Não",
      buttonColor: newButtonColor = "secondary",
      confirmCallback: newConfirmCallback,
      cancelCallback: newCancelCallback,
    }: IConfirmationAlert) => {
      title.value = newTitle ?? "";
      message.value = newMessage ?? "";
      confirmationButtonLabel.value = newConfirmationButtonLabel ?? "";
      cancellationButtonLabel.value = newCancellationButtonLabel ?? "";
      buttonColor.value = newButtonColor ?? "";
      confirmCallback = newConfirmCallback;
      cancelCallback = newCancelCallback;
      toggleModal("confirm_alert_modal");
    },
  );
});

const cancelAction = () => {
  if (cancelCallback) {
    cancelCallback();
  }
  toggleModal("confirm_alert_modal");
};

const alertClosed = () => {
  cancelAction();
};

const confirmAction = async () => {
  try {
    submitting.value = true;
    await confirmCallback();
    toggleModal("confirm_alert_modal");
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
};
</script>
<style scoped></style>
